(function(){
  var CFG = window.SOCHU_LANDING_CONFIG || {};
  var SOCHU = {
    /* storeBase "" -> use THIS store's own cart/checkout (correct when the
       landing page/section lives on the sochu.in store itself). The Shopify
       section injects these values from its theme-editor settings; the
       standalone preview pins storeBase to https://sochu.in so its CTAs
       work from anywhere. */
    storeBase: CFG.storeBase || "",
    variantId: CFG.variantId || "48245849784534",
    productUrl: CFG.productUrl || "https://sochu.in/products/sochu-thinking-feeling-and-doing-series-total-36-books"
  };
  var FALLBACK = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" width="640" height="480"><rect width="640" height="480" fill="#F4F4F4"/><text x="320" y="244" font-family="sans-serif" font-size="20" fill="#B9B9B9" text-anchor="middle">Image coming soon</text></svg>');
  function each(list, fn){ Array.prototype.forEach.call(list, fn); }

  var roots = document.querySelectorAll("#sochu-landing");
  for (var ri = 0; ri < roots.length; ri++) { init(roots[ri]); }
  return;

  function init(root){
    if (root.getAttribute("data-sl-init")) return;
    root.setAttribute("data-sl-init", "1");

    root.addEventListener("error", function(e){
      var t = e.target;
      if (t && t.tagName === "IMG" && !t.dataset.fbk) { t.dataset.fbk = "1"; t.classList.add("sl-fbk"); t.src = FALLBACK; }
    }, true);

  /* Buy blocks: quantity stepper + real sochu.in checkout (single CTA:
     "Buy it now" -> /cart/{variant}:{qty} checkout permalink) */
  each(root.querySelectorAll("[data-buy-block]"), function(block){
    var qty = 1;
    var val = block.querySelector("[data-qty-val]");
    var minus = block.querySelector("[data-qty-minus]");
    var plus = block.querySelector("[data-qty-plus]");
    function render(){ val.textContent = qty; minus.disabled = qty <= 1; }
    minus.addEventListener("click", function(){ if (qty > 1) { qty--; render(); } });
    plus.addEventListener("click", function(){ if (qty < 9) { qty++; render(); } });
    block.querySelector("[data-buy-btn]").addEventListener("click", function(){
      window.location.href = (SOCHU.storeBase || "") + "/cart/" + SOCHU.variantId + ":" + qty;
    });
    var shareBtn = block.querySelector("[data-share-btn]");
    var shareLabel = shareBtn.querySelector("[data-share-label]");
    var shareT;
    shareBtn.addEventListener("click", function(){
      function copied(){
        shareLabel.textContent = "Link copied!";
        clearTimeout(shareT);
        shareT = setTimeout(function(){ shareLabel.textContent = "Share"; }, 2000);
      }
      if (navigator.share) { navigator.share({ title: document.title, url: SOCHU.productUrl }).catch(function(){}); }
      else if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(SOCHU.productUrl).then(copied).catch(function(){});
      }
    });
  });

  /* Mobile sticky CTA: book details (cover + title + price) + one compact
     "Buy it now" button pinned to the bottom edge. Appears after scrolling
     past the only buy section; CSS hides it on desktop (>=768px). Same
     checkout permalink as the in-page CTA. */
  var sticky = root.querySelector("[data-sl-sticky]");
  var stickyBtn = root.querySelector("[data-sl-sticky-btn]");
  var firstBlock = root.querySelector("[data-buy-block]");
  if (sticky && stickyBtn) {
    stickyBtn.addEventListener("click", function(){
      var q = 1;
      var sval = firstBlock ? firstBlock.querySelector("[data-qty-val]") : null;
      if (sval) { var n = parseInt(sval.textContent, 10); if (n > 0) q = n; }
      window.location.href = (SOCHU.storeBase || "") + "/cart/" + SOCHU.variantId + ":" + q;
    });
    if (firstBlock && "IntersectionObserver" in window) {
      var io = new IntersectionObserver(function(entries){
        var e = entries[entries.length - 1];
        sticky.classList.toggle("sl-sticky-on", e.boundingClientRect.top < 0 && !e.isIntersecting);
      }, { threshold: 0 });
      io.observe(firstBlock);
    } else {
      sticky.classList.add("sl-sticky-on");
    }
  }

  /* Video testimonials scroller */
  each(root.querySelectorAll("[data-vt-wrap]"), function(wrap){
    var track = wrap.querySelector("[data-vt-track]");
    var btn = wrap.querySelector("[data-vt-next]");
    if (!track || !btn) return;
    btn.addEventListener("click", function(){
      var card = track.querySelector("[data-vt-card]");
      var step = card ? card.offsetWidth + 24 : track.clientWidth * 0.8;
      var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 8;
      track.scrollTo({ left: atEnd ? 0 : track.scrollLeft + step, behavior: "smooth" });
    });
  });

  /* Sample-page carousels (Books 1-3) */
  each(root.querySelectorAll("[data-carousel]"), function(c){
    var slides;
    try { slides = JSON.parse(c.getAttribute("data-slides")); } catch (err) { return; }
    if (!slides || !slides.length) return;
    var idx = 0;
    var img = c.querySelector("[data-slide-img]");
    var pages = c.querySelectorAll("[data-page]");
    function render(){
      var target = slides[idx];
      img.style.opacity = "0";
      var pre = new Image();
      pre.onload = function(){ img.src = target.src; img.alt = target.alt; img.style.opacity = "1"; };
      pre.onerror = function(){ img.src = FALLBACK; img.classList.add("sl-fbk"); img.style.opacity = "1"; };
      pre.src = target.src;
      each(pages, function(p, i){
        p.classList.toggle("is-active", i === idx);
        p.setAttribute("aria-current", i === idx ? "page" : "false");
      });
    }
    function prev(){ idx = (idx - 1 + slides.length) % slides.length; render(); }
    function next(){ idx = (idx + 1) % slides.length; render(); }
    each(c.querySelectorAll("[data-cprev]"), function(b){ b.addEventListener("click", prev); });
    each(c.querySelectorAll("[data-cnext]"), function(b){ b.addEventListener("click", next); });
    each(pages, function(p, i){ p.addEventListener("click", function(){ idx = i; render(); }); });
  });
  }
})();
